import { useQuery } from "@tanstack/react-query";
import { ProviderControllerApi } from "@/services";
import { getConfigObject, useBaseData } from "@/utils/utils";

/** The fields `/provider/profile-light` returns — no many-to-many relations. */
export interface ProviderProfileLight {
  uuid?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  avatar?: string;
}

/** Profile without the many-to-many relations; keyed under `provider-profile` so existing invalidations still refresh it. */
export const useProviderProfileLight = (
  tenantId?: string,
  enabled?: boolean
): useBaseData<ProviderProfileLight> =>
  useQuery({
    queryKey: ["provider-profile", "light", tenantId],
    enabled: !!tenantId && tenantId !== "none" && (enabled ?? true),
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ProviderControllerApi(getConfigObject())
        .getProfileLight(tenantId)
        .then((res) => res?.data as never),
  });
